import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { MenuItem, Select } from "@mui/material";
import ReactCountryFlag from "react-country-flag";
import { ClientContext } from "../../store/context";
import { useGet, usePost } from "../hooks/Hooks";
import { convertToLanguage } from "../utils/generalUtils";
import { navBarKeys } from "../utils/constants";
import { keysApi, languageApi, siteValuesApi } from "../api/GardenoApi";
import { useNavigate } from "react-router-dom";

const drawerWidth = 240;

function NavBar(props) {
  const navigate = useNavigate();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const { language, setLanguage } = React.useContext(ClientContext);
  const [languages, languagesError] = useGet(languageApi.getAllLanguages);
  const [keys, keysError] = usePost(
    keysApi.getAllKeys,
    convertToLanguage(language),
    navBarKeys
  );
  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <img style={{ width: "95px" }} src={require("../assets/logo.png")} />
      <Divider />
      <List>
        <ListItem key={"home"} disablePadding>
          <ListItemButton sx={{ textAlign: "center" }}>
            <ListItemText
              onClick={() => navigate("/")}
              primary={keys?.settings?.NAVIGATION_HOME}
            />
          </ListItemButton>
        </ListItem>
        <ListItem key={"fleet"} disablePadding>
          <ListItemButton sx={{ textAlign: "center" }}>
            <ListItemText
              onClick={() => navigate("/fleet")}
              primary={keys?.settings?.NAVIGATION_FLEET}
            />
          </ListItemButton>
        </ListItem>
        <ListItem key={"about"} disablePadding>
          <ListItemButton sx={{ textAlign: "center" }}>
            <ListItemText
              onClick={() => navigate("/about")}
              primary={keys?.settings?.NAVIGATION_ABOUT}
            />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );
  const handleChange = (event) => setLanguage(event.target.value);

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex", flex: 2, minHeight: "85px" }}>
      <CssBaseline />
      <AppBar
        component="nav"
        sx={{
          height: "inherit",
          display: "flex",
          backgroundColor: "#06283D",
          flexDirection: "column",
        }}
      >
        <Toolbar
          sx={{ width: { xs: "95%", lg: "60%" }, alignSelf: "center", flex: 1 }}
          disableGutters={true}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}
          >
            <img
              style={{ width: "95px", cursor: "pointer" }}
              src={require("../assets/logo.png")}
              onClick={() => navigate("/")}
            ></img>
          </Typography>
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            <Button
              key={"home_btn"}
              onClick={() => navigate("/")}
              sx={{ color: "#fff" }}
            >
              {keys?.settings?.NAVIGATION_HOME}
            </Button>
            <Button
              key={"fleet_btn"}
              onClick={() => navigate("/fleet")}
              sx={{ color: "#fff" }}
            >
              {keys?.settings?.NAVIGATION_FLEET}
            </Button>
            <Button
              key={"about_btn"}
              onClick={() => navigate("/about")}
              sx={{ color: "#fff" }}
            >
              {keys?.settings?.NAVIGATION_ABOUT}
            </Button>
          </Box>
          <Select
            defaultValue={language}
            value={language}
            sx={{
              boxShadow: "none",
              ".MuiOutlinedInput-notchedOutline": { border: 0 },
            }}
            renderValue={(selected) => (
              <ReactCountryFlag countryCode={selected} svg />
            )}
            onChange={handleChange}
          >
            {languages?.map((country) => (
              <MenuItem
                key={convertToLanguage(country)}
                value={convertToLanguage(country)}
              >
                <ReactCountryFlag
                  countryCode={convertToLanguage(country)}
                  svg
                />
              </MenuItem>
            ))}
          </Select>
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
}

export default NavBar;
